'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoHubot = function GoHubot(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 2.5c-11.1 0-20 8.9-20 20v10s2.5 5 5 5h30s5-2.5 5-5v-10c0-11.1-8.9-20-20-20z m3.8 30h-7.5c-0.8 0-1.3-0.5-1.3-1.2s0.5-1.3 1.3-1.3h7.5c0.7 0 1.2 0.5 1.2 1.3s-0.5 1.2-1.2 1.2z m11.2-5c0 1.3-1.2 2.5-2.5 2.5h-5c0-1.2-1.2-2.5-2.5-2.5h-10s-2.5 1.3-2.5 2.5h-5s-2.5-1.2-2.5-2.5v-14.1c3-5 8.6-8.4 15-8.4s12 3.4 15 8.4v14.1z m-5-15h-20s-2.5 1.3-2.5 2.5v5s1.3 2.5 2.5 2.5h20s2.5-1.2 2.5-2.5v-5s-1.2-2.5-2.5-2.5z m0 5l-2.5 2.5h-5l-2.5-2.5-2.5 2.5h-5l-2.5-2.5v-2.5h2.5l2.5 2.5 2.5-2.5h5l2.5 2.5 2.5-2.5h2.5v2.5z' })
        )
    );
};

exports.default = GoHubot;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/hubot.js
// module id = 1936
// module chunks = 0